export const brand = {
  name: 'KAYLUS',
  appName: 'KAYLUS',
  tagline: 'Smart savings for everyday shopping.',
  navLogoText: 'KAYLUS',
  ctaLabel: 'Book a Demo',
  bookDemoPath: '/book-a-demo',
  calendlyUrl: 'https://calendly.com/ryan-clipitsavings',
  siteUrl:
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '',
  seo: {
    title: 'KAYLUS - Smarter Savings for Everyday Shopping',
    description:
      'KAYLUS helps shoppers discover smarter savings and helps brands reach customers with timely, high-intent offers.',
    keywords:
      'KAYLUS, savings, offers, shopping, retail media, shopper engagement, brand loyalty',
    ogImage: '/home/rebrand/coming-soon.webp',
  },
  contact: {
    email: '',
  },
  socialLinks: [],
  assets: {
    logo: '/home/rebrand/kaylus-blue-logo.webp',
    checkIcon: '/shared/brand-check.svg',
    home: {
      heroPhone: '/home/rebrand/hero-phone.webp',
      heroAisle: '/home/rebrand/aisle-couple.webp',
      shoppersGrid: '/home/rebrand/New-shopper-grid.webp',
      brandsGrid: '/home/rebrand/New-brand-grid.webp',
      howItWorksSvg: '/home/rebrand/How-it-works.svg',
      discountStrip: '/home/rebrand/discount-strip.webp',
      brandPortal: '/home/rebrand/brand-portal.webp',
      comingSoon: '/home/rebrand/coming-soon.svg',
      ctaBackground: '/home/rebrand/cta-background.webp',
    },
  },
};

export const buildPageTitle = (title) => `${title} | ${brand.name}`;
